export enum ModalSizeEnum {
  Big = 'big',
  Medium = 'medium',
  Small = 'small',
}
